<template>
    <div class="card-primary foto-profile">
        
          <!-- <img class="img-profile"  :src="'./assets/profile/full/'+this.$route.params.name+'-full.png'"  alt=""> -->
          <img class="img-profile"  :src="require(`@/assets/profile/full/${this.$route.params.name}-full.png`)"  alt="">
      </div>
</template>

<script>
export default {
    name:"PhotoProfile"
}
</script>


// WEBPACK FOOTER //
// src/components/User/PhotoProfile.vue